export default __webpack_public_path__ + "static/media/DNo.31-0.7df3bc30.jpg";